import { useMemo } from 'react'
import { ActionDropdown, ListTable } from '@nv/components'
import clsx from 'clsx'
import { t } from 'i18next'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from './MatchesTable.module.scss'

export const MatchesTable = ({ matches, user }) => {
  const { i18n } = useTranslation()
  const navigate = useNavigate()
  const currentLanguage = i18n.language

  const otherMatchApproved = matches.some((d) => d.registered)
  const matchRemoved = matches.some((d) => d.removed)
  const thisMatchApproved = matches.some((d) => d.registered && d.registeredVoterId === user.voterInfo._id)

  const getStatus = (info) => {
    if (info.removed) return 'removed'
    else if (info.voted) return 'voted'
    else if (info.registered) return 'registered'
    return 'registered'
  }

  const columns = useMemo(() => {
    return [
      {
        accessorKey: 'electorId',
        cell: (info) => info.getValue() || '',
        header: () => t('admin.electorsList.voterId'),
      },
      // {
      //   accessorKey: 'knownIdNumber',
      //   cell: (info) =>
      //     info.getValue() ? (
      //       <span
      //         className={clsx({
      //           [styles['match']]: user.voterInfo.knownIdNumber === info.getValue(),
      //           [styles['mis-match']]: user.voterInfo.knownIdNumber !== info.getValue(),
      //         })}
      //       >
      //         {info.getValue()}
      //       </span>
      //     ) : (
      //       ''
      //     ),
      //   header: () => t('admin.electorsList.knownIdNumber'),
      // },
      {
        accessorKey: 'fullName',
        cell: (info) => info.getValue() || '',
        header: () => t('form.labels.name'),
      },
      {
        accessorKey: 'address.fullAddress',
        cell: (info) => {
          return info.getValue() ? (
            <span
              className={clsx({
                [styles['match']]: user.voterInfo.address.fullAddress === info.getValue(),
                [styles['mis-match']]: user.voterInfo.address.fullAddress !== info.getValue(),
              })}
            >
              {info.getValue()}
            </span>
          ) : (
            ''
          )
        },
        header: () => t('form.labels.address'),
      },
      {
        accessorKey: 'dateOfBirth',
        cell: (info) => info.getValue() || '',
        header: () => t('form.labels.dateOfBirth'),
      },
      {
        accessorKey: 'registered',
        cell: (info) =>
          !getStatus(info.row.original) ? (
            ''
          ) : (
            <span className={clsx(styles[`status-label`], styles[`status-label__${getStatus(info.row.original)}`])}>
              {t(`admin.electorsList.eligibleVoterStatusOptions.${getStatus(info.row.original)}`)}
            </span>
          ),
        header: () => t('admin.electorsList.registered'),
      },
      {
        id: 'Action',
        accessorKey: 'action',
        cell: (info) => (
          <ActionDropdown
            values={[{ value: 'View', label: t('admin.dropdown.view') }]}
            onCallback={(choice) => {
              const voterId = info.row.original?.id
              switch (choice) {
                case 'View':
                  if (voterId) navigate(`/admin/elector-details/${voterId}`)
                  else alert('User is not viewable.')
                  break
              }
            }}
          />
        ),
        header: () => <span>{t('buttons.action')}</span>,
      },
    ]
  }, [currentLanguage])

  return (
    <div className={styles['table-container']}>
      <h2 className={styles['header']}>
        {t('admin.electorsDetails.profileMatch')}
        {thisMatchApproved && <span className={styles['matched-label']}>{t('admin.electorsDetails.matchApproved')}</span>}
        {otherMatchApproved && !thisMatchApproved && (
          <span className={styles['removed-label']}>{t('admin.electorsDetails.matchAlreadyApproved')}</span>
        )}
        {matchRemoved && <span className={styles['removed-label']}>{t('admin.electorsDetails.matchRemoved')}</span>}
      </h2>
      <ListTable data={matches} columns={columns} loading={false} />
    </div>
  )
}
